import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Translate, ValidatedBlobField, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { createEntity, getEntity, reset, updateEntity } from './device.reducer';

export const DeviceUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const deviceEntity = useAppSelector(state => state.device.entity);
  const loading = useAppSelector(state => state.device.loading);
  const updating = useAppSelector(state => state.device.updating);
  const updateSuccess = useAppSelector(state => state.device.updateSuccess);

  const handleClose = () => {
    props.history.push('/device' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...deviceEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          deviceType: 'EBS',
          ...deviceEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.device.home.createOrEditLabel" data-cy="DeviceCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.device.home.createOrEditLabel">Create or edit a Device</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="device-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                  className="d-none"
                />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.device.deviceType')}
                id="device-deviceType"
                name="deviceType"
                required
                data-cy="deviceType"
                type="select"
              >
                <option value="EBS">{translate('fleetSenseApp.DeviceType.EBS')}</option>
                <option value="MCD">{translate('fleetSenseApp.DeviceType.MCD')}</option>
                <option value="MIO">{translate('fleetSenseApp.DeviceType.MIO')}</option>
                <option value="TDI">{translate('fleetSenseApp.DeviceType.TDI')}</option>
                <option value="RFID">{translate('fleetSenseApp.DeviceType.RFID')}</option>
                <option value="INCLINOMETER">{translate('fleetSenseApp.DeviceType.INCLINOMETER')}</option>
                <option value="LINING">{translate('fleetSenseApp.DeviceType.LINING')}</option>
                <option value="RODOCAL">{translate('fleetSenseApp.DeviceType.RODOCAL')}</option>
                <option value="ST310U">{translate('fleetSenseApp.DeviceType.ST310U')}</option>
                <option value="ST340UR">{translate('fleetSenseApp.DeviceType.ST340UR')}</option>
                <option value="XG4780">{translate('fleetSenseApp.DeviceType.XG4780')}</option>
                <option value="TPMS">{translate('fleetSenseApp.DeviceType.TPMS')}</option>
                <option value="ST4305">{translate('fleetSenseApp.DeviceType.ST4305')}</option>
                <option value="ST4315">{translate('fleetSenseApp.DeviceType.ST4315')}</option>
                <option value="ST8310">{translate('fleetSenseApp.DeviceType.ST8310')}</option>
                <option value="EFMA">{translate('fleetSenseApp.DeviceType.EFMA')}</option>
                <option value="TELTONIKA">{translate('fleetSenseApp.DeviceType.TELTONIKA')}</option>

                {/* <option value="VIRTUAL">{translate('fleetSenseApp.DeviceType.VIRTUAL')}</option> */}
              </ValidatedField>
              <ValidatedField
                label={translate('fleetSenseApp.device.manufacturer')}
                id="device-manufacturer"
                name="manufacturer"
                required
                data-cy="manufacturer"
                type="text"
              />
              <ValidatedField label={translate('fleetSenseApp.device.model')} id="device-model" name="model" required data-cy="model" type="text" />
              <ValidatedBlobField label={translate('fleetSenseApp.device.image')} id="device-image" name="image" data-cy="image" isImage accept="image/*" />
              <ValidatedField
                label={translate('fleetSenseApp.device.description')}
                id="device-description"
                name="description"
                data-cy="description"
                type="textarea"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/device" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DeviceUpdate;
